export const FACE_NAV_WIDTH = '288px';